export interface SupportedLanguage {
  name: string;
  label: string;
  code: string;
  i18nCode: string;
}

export const DEFAULT_LANGUAGE = {
  name: 'English',
  label: 'English',
  code: 'en',
  i18nCode: 'en-US',
};

export const SUPPORTED_LANGUAGES = [
  DEFAULT_LANGUAGE,
  {
    name: 'Spanish',
    label: 'Español',
    code: 'es',
    i18nCode: 'es',
  },
];
